export const messages = {
  en: {
    attrValueManage: {
      queryCondition: 'Query Conditions',
      inputValue: 'Please enter value',
      selectDisplay: 'Please select display',
      yes: 'Yes',
      no: 'No',
      inputValueName: 'Please enter value name',
      query: 'Query',
      reset: 'Reset',
      attributeValue: 'Attribute Value',
      add: 'Add',
      back: 'Back',
      valueName: 'Value Name',
      value: 'Value',
      valueId: 'Value ID',
      display: 'Display',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addAttrValue: {
      addAttributeValue: 'Add Attribute Value',
      value: 'Value',
      requiredValue: 'Required, please enter value',
      valueName: 'Value Name',
      requiredValueName: 'Required, please enter value name',
      display: 'Display',
      requiredDisplay: 'Required, please select display',
      save: 'Save',
      cancel: 'Cancel',
      addSuccess: 'Added successfully',
      valueRequired: 'Value is required',
      valueMaxLength: 'Value cannot exceed 200 characters',
      valueNameRequired: 'Value name is required',
      valueNameMaxLength: 'Value name cannot exceed 200 characters',
      displayRequired: 'Display is required'
    },
    editAttrValue: {
      editAttributeValue: 'Edit Attribute Value',
      value: 'Value',
      requiredValue: 'Required, please enter value',
      valueName: 'Value Name',
      requiredValueName: 'Required, please enter value name',
      display: 'Display',
      requiredDisplay: 'Required, please select display',
      save: 'Save',
      cancel: 'Cancel',
      editSuccess: 'Modified successfully',
      valueRequired: 'Value is required',
      valueMaxLength: 'Value cannot exceed 200 characters',
      valueNameRequired: 'Value name is required',
      valueNameMaxLength: 'Value name cannot exceed 200 characters',
      displayRequired: 'Display is required',
      valueIdRequired: 'Value ID is required'
    },
    deleteAttrValue: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteAttributeValue: 'Confirm to delete attribute value',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully'
    }
  },
  zh: {
    attrValueManage: {
      queryCondition: '查询条件',
      inputValue: '请输入值',
      selectDisplay: '请选择显示',
      yes: '是',
      no: '否',
      inputValueName: '请输入值名称',
      query: '查询',
      reset: '重置',
      attributeValue: '属性值',
      add: '添加',
      back: '返回',
      valueName: '值名称',
      value: '值',
      valueId: '值ID',
      display: '显示',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addAttrValue: {
      addAttributeValue: '添加属性值',
      value: '值',
      requiredValue: '必填，请填写值',
      valueName: '值名称',
      requiredValueName: '必填，请填写值名称',
      display: '显示',
      requiredDisplay: '必填，请选择显示',
      save: '保存',
      cancel: '取消',
      addSuccess: '添加成功',
      valueRequired: '值不能为空',
      valueMaxLength: '值不能超过200位',
      valueNameRequired: '值名称不能为空',
      valueNameMaxLength: '值名称不能超过200位',
      displayRequired: '显示不能为空'
    },
    editAttrValue: {
      editAttributeValue: '修改属性值',
      value: '值',
      requiredValue: '必填，请填写值',
      valueName: '值名称',
      requiredValueName: '必填，请填写值名称',
      display: '显示',
      requiredDisplay: '必填，请选择显示',
      save: '保存',
      cancel: '取消',
      editSuccess: '修改成功',
      valueRequired: '值不能为空',
      valueMaxLength: '值不能超过200位',
      valueNameRequired: '值名称不能为空',
      valueNameMaxLength: '值名称不能超过200位',
      displayRequired: '显示不能为空',
      valueIdRequired: '值ID不能为空'
    },
    deleteAttrValue: {
      confirmOperation: '请确认您的操作',
      confirmDeleteAttributeValue: '确定删除属性值',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}